import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { APP_CONFIG } from '@flexo/reducers';

export const AppConfigResolver = () => {
  const dispatch = useDispatch();
  const hasRequestedRef = useRef(false);
  const fetchStatus = useSelector(
    (state: any) => state?.appConfig?.FetchAppConfigAsyncStatus
  );

  useEffect(() => {
    if (hasRequestedRef.current) return;
    if (fetchStatus === 'SUCCESS') return;
    if (fetchStatus === 'PENDING') {
      hasRequestedRef.current = true;
      return;
    }
    hasRequestedRef.current = true;
    dispatch(APP_CONFIG.FetchAppConfigAsync() as any);
  }, [dispatch, fetchStatus]);

  return null;
};
